import React from "react";
import styles from "./WorksBody.module.css";

import image1 from "../../../../assets/Images/Tsundoku/nextjs_visual.webp";

const WorksBody = () => {
  return (
    <div className={styles.entireWorksBody}>
      <div className={styles.worksBodyContainer}>
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeaderIntro}>
            ✨ Key Features
          </h2>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Achieved 90% reduction in media weight and 60% faster page loads
                through a deep technical refactor—resulting in 95–100 Lighthouse
                scores.
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Dynamic page generation and Server-side rendering (SSR) with
                Next.js using slug-based routes from my Sanity Studio's database
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Real-time draft previews with session-based logic through
                selective distribution of cookies
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Category-weighted content recommendations with custom scoring
                algorithm
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Responsive UI optimized for readability, accessibility, and
                performance
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                SEO-friendly content via structured Sanity CMS integration
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Optimized image delivery using Sanity CDN and next/image
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>Contact form powered by React Hook Form and EmailJS</span>
            </p>
          </div>
        </div>
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeaderIntro}>
            ⚙️ Implementation Details{" "}
          </h2>
          <h2 className={styles.worksBodyKeyPointsHeader}>
            Live Preview with Draft Mode
          </h2>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Connected real-time preview routes with cookie-based session
                logic
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Used iframe preview in Sanity Studio to reflect content changes
                instantly
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Isolated preview content to dev and authorized sessions only
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Automated, secure editorial workflow from CMS authoring to live
                frontend rendering
              </span>
            </p>
          </div>
        </div>
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeader}>
            Dynamic Content Rendering
          </h2>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Used Next.js App Router for dynamic page generation via slug
                hydration
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Dynamic image delivery tailored to user device using
                <a href="https://www.sanity.io/docs/presenting-images">
                  {" "}
                  @sanity/image-url{" "}
                </a>
                and{" "}
                <a href="https://nextjs.org/docs/pages/api-reference/components/image">
                  next/image
                </a>
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Structured fallback rendering for scalable content and 404
                support
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>Fully mobile-optimized pages styled with TailwindCSS</span>
            </p>
          </div>
        </div>
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeader}>
            CMS Integration with GROQ
          </h2>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Wrote nested GROQ queries to fetch structured block content
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Enabled flexible layouts via GROQ-to-UI mapping across all post
                types
              </span>
            </p>
          </div>
        </div>
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeader}>
            Content Recommendation System
          </h2>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Implemented custom scoring logic to suggest related posts based
                on category matches
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Dynamically ranked content relevance using an injected weight
                variable
              </span>
            </p>
          </div>
        </div>

        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeader}>
            Form & Contact Handling
          </h2>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Created a contact form using react-hook-form and{" "}
                <a href="https://www.npmjs.com/package/@emailjs/browser">
                  @emailjs/browser
                </a>
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Included validation, animation, and submission feedback handling
              </span>
            </p>
          </div>
        </div>

        <div>
          <img
            src={image1}
            alt="Illustration of Next.js key features and benefits."
            className={styles.worksBodyImage}
            style={{ border: "1px solid #E4E5DA" }}
          />
        </div>
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeader}>
            🔐 Technical Highlights
          </h2>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                <b>CMS-to-Frontend Pipeline:</b> Full-stack editorial flow from
                authoring to public page
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                <b>Typed UI Components:</b> Built with TypeScript for safety and
                scale
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                <b>Preview Isolation:</b> Draft mode gated by session cookie and
                environment checks
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                <b>Optimized Assets:</b> Used{" "}
                <a href="https://www.sanity.io/docs/presenting-images">
                  {" "}
                  @sanity/image-url{" "}
                </a>{" "}
                and{" "}
                <a href="https://nextjs.org/docs/pages/api-reference/components/image">
                  next/image
                </a>{" "}
                for device-aware delivery
              </span>
            </p>
          </div>
        </div>
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeader}>💡 What I Learned</h2>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Building from scratch with CMSs taught me to think in schemas,
                not just components
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Optimization is more than speed—it's about user trust,
                accessibility, and intent
              </span>
            </p>
          </div>
        </div>
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeader}>
            📈 Why This Matters
          </h2>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Tsundoku shows how I can build and maintain a content platform
                from backend to frontend. It:
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Demonstrates proficiency in Next.js, TypeScript, and modern SSR
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Highlights ability to integrate and customize a headless CMS for
                publishing workflows
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Reflects a well-rounded approach to design systems, performance,
                and editor needs
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Was tested in real usage by publishing multiple long-form
                articles and iterating on feedback
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                It's more than a simple blog—it’s a scalable content platform
                connecting thoughtful design, structured content, and clean
                code.
              </span>
            </p>
          </div>
        </div>
        <div className={styles.worksBodyKeyPointsContainer}>
          <h2 className={styles.worksBodyKeyPointsHeader}>📝 Learn More</h2>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Curious about the behind-the-scenes decisions and challenges of
                this project?
              </span>
            </p>
          </div>
          <div className={styles.worksBodyKeyPointsDetailContainer}>
            <div className={styles.worksBodyKeyPointsDetailBulletContainer}>
              <div className={styles.worksBodyKeyPointsDetailBullet} />
            </div>
            <p className={styles.worksBodyKeyPointsDetail}>
              <span>
                Read the deep dive on how and why I built Tsundoku{" "}
                <a href="https://www.tsundoku.blog/posts/from-curious-to-coding-building-a-blog-with-next-js-sanity-typescript-and-tailwind">
                  here
                </a>
                .
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorksBody;
